//Custom JS by Young Pixel
$( document ).ready(function() {

    //add simple support for background images:
    document.addEventListener('lazybeforeunveil', function(e){
      var bg = e.target.getAttribute('data-bg');
      if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
      }
    });

    // Element to lock scroll on, when scroll lock plugin is called
    var _$scrollableElement = 'document.body';

    // Header animations
    // Cache Header
    var $header = $('#header .site-header');
    // Get height of header to use later as starting point
    var $hHeight = $header.parent().height();
    // Set initial position to current position on page
    var prevTop = $(window).scrollTop();
    // Scroll event
    $(window).on('scroll', function(e) {
        st = $(this).scrollTop(); // Set scroll location

       if (st > 50 ) {
            $header.addClass('header-solid header-scrolling');
          	$('.top-banner').hide();
        } else {
            $header.removeClass('header-solid header-scrolling');
          	$('.top-banner').fadeIn();
        }
        prevTop = st;
    });

    // Has Announcement Bar enabled
    if($('.announcement-bar').length) {
      $('body').addClass('has-announcement-bar');
    }

    // MObile nav toggles
    var $mobileNavTrigger= $('.mobile-menu-toggle'),
        $mobileNav = $('.mobile-menu-wrapper'),
        $mobileSublistTrigger= $('.mobile-nav__sublist-trigger'),
        showDropdownClass = '.show-dropdown',
        $closeMobileMenu = $('.close-mobile-menu'),
        $topBar = $('.announcement-bar');

    $mobileNavTrigger.click(function (){
      var $scrollableElement = $('.mobile-menu-wrapper');
      $('#mobile-menu').hide().fadeIn();
      $(this).attr('aria-expanded','true');
      $mobileNav.addClass('js-menu--is-open').show();
      $topBar.hide();
      //disablePageScroll('.mobile-menu-wrapper');
      scrollLock.disablePageScroll($scrollableElement);
      $('.site-header').removeClass('header-scrolling').addClass('header-solid');
    });
    $closeMobileMenu.click(function (){
      $mobileNavTrigger.attr('aria-expanded','false');
      $('.site-header').removeClass('header-solid');
      $mobileNav.fadeOut().removeClass('js-menu--is-open');
      $topBar.fadeIn();
      scrollLock.enablePageScroll();
    });


    // CONTACT POPUP
    var $contactPopupTrigger= $('.contact-popup-trigger'),
        $contactPopup = $('#contactPopup'),
        $contactPopupWrapper = $('.contact-popup-wrapper'),
        $closeContactPopup = $contactPopup.find('.close-popup');

    $contactPopupTrigger.click(function (e){
      e.preventDefault();
      var $scrollableElement = $contactPopup;
      $contactPopup.addClass('is-open');
      scrollLock.disablePageScroll($scrollableElement);
    });
    $closeContactPopup.click(function (e){
      $contactPopup.removeClass('is-open');
      scrollLock.enablePageScroll();
    });

    //Preorder POPUP

    var $preorderPopupTrigger= $('#preorder-popup-trigger'),
        $preorderPopup = $('#preorderPopup'),
        $preorderPopupWrapper = $('.preorder-popup-wrapper'),
        $closePreorderPopup = $preorderPopup.find('.close-popup');

    $preorderPopupTrigger.click(function (e){
      e.preventDefault();
      var $scrollableElement = $preorderPopup;
      $preorderPopup.addClass('is-open');
      scrollLock.disablePageScroll($scrollableElement);
    });
    $closePreorderPopup.click(function (e){
      $preorderPopup.removeClass('is-open');
      scrollLock.enablePageScroll();
    });

    // Mega menus dropdown
    var _$menuLink = $('a.megamenu-trigger');
    var _$linkParent, _$sub;

    _$menuLink.click(function(e) {
      e.preventDefault();
      var $scrollableElement = $('.mobile-menu-wrapper');
      //$(".site-header").addClass("scrolled");

      _$linkParent = $(this).parent();
      _$sub = _$linkParent.find('.sub');

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.sub').removeClass('open');
         $('#overlay').remove();
         scrollLock.enablePageScroll();
      } else {
        $(this).addClass('active');
        $(".sub").not(_$sub).removeClass('open');
        _$menuLink.not(this).removeClass('active');
        _$sub.addClass('open');
        $('body').append('<div id="overlay" class="overlay z1 dropdown"></div>');//.addClass('lock-scroll');
        $('#overlay').addClass('show');
        scrollLock.disablePageScroll($scrollableElement);
        e.stopPropagation();
      }
    });

    // Side cart functions
    $('.cart-side-toggle').click(function (){
      var $scrollableElement = $('#CartSide');
      $('.close-mobile-menu').click();
      $('#CartSide').toggleClass('open');

      if ($('#overlay').length == 0) {
        $('body').append('<div id="overlay" class="overlay show z10"></div>');
        if($(window).width() > 769) {
          scrollLock.disablePageScroll($scrollableElement);
        }
        //scrollLock.disablePageScroll($('.top-cart-items'));
      } else {
        if (!$('.sub').hasClass('open')) {
          $('#overlay').remove();
        } else {
          $('#overlay').addClass('z10');
          $('.sub').removeClass('open');
        }
        if($(window).width() > 769) {
          scrollLock.disablePageScroll($scrollableElement);
        }
        //scrollLock.disablePageScroll($('.top-cart-items'));
      }
    });

    // Search Popup
    $('#search-toggle').click(function (){

        var $scrollableElement = $('.menu-search.sub');
        scrollLock.disablePageScroll($scrollableElement);
        clearPopups();
        $('body').append('<div id="overlay" class="overlay show"></div>');
        $scrollableElement.addClass('open');

    });

    // Outside of popups clicks
    $(document).mouseup(function (e) {
      var drawers = $("#CartSide, .sub.open");
      if (!drawers.is(e.target) && drawers.has(e.target).length === 0) {
      // … nor a descendant-child of the container
        clearPopups();
      }
    });


    function clearPopups() {
          $('#overlay').remove();
          $('.cart.top-cart, .sub').removeClass('open');
          $('#CartSide').removeClass('open');
          scrollLock.enablePageScroll();
        }

      $(document).on('click', '#overlay, .close-cart', function (e) {
        clearPopups();
      });



  function statusTagsCart () {
    $('#CartSide').find('.item-specs li').each(function() {
      var val = $(this).html();
      //console.log('item spec val: ' + val);

      if (val.indexOf("Pre-order") >= 0) {
        $(this).addClass('preorder');
      } else if (val.indexOf("Sale") >= 0) {
        $(this).addClass('onsale');
      }

    });
  }
  statusTagsCart ();

  var pathname = '';
  $(document).on('cart.requestComplete', function(event, cart) {
    var cart_qty = CartJS.cart.item_count;
    if (cart_qty > 0) {
      $('.cart-count').removeClass('hidden-count');
    } else {
      $('.cart-count').addClass('hidden-count');
    }
    if (pathname != '/cart') {
      if (!$('#Cart-Side').hasClass('open')) {
        $('.cart-page-link').click();
      }
    }
    statusTagsCart ();
    // Update height of the products container
    //let cartHeight = $('.top-cart-items').height()
    //$('.top-cart-items').css('height',cartHeight)

  });

  /* Mailchimp */
  var mailchimpForm = $('#mc-embedded-subscribe-form');
  mailchimpForm.ajaxChimp({
    callback: function(response) {
      console.log('Mailchimp response ' + response.msg);
      if (response && response.result == 'success'){
        mailchimpForm.addClass('hidden');
        $('.consent').addClass('hidden');
        response.msg = "To complete the subscription process, please click the link in the email we just sent you. <br/>Your voucher code will be sent by email, enter it during checkout and get an extra 10 percent off.";
        $('#mce-error-response').addClass('hidden');
        $('#mce-success-response').removeClass('hidden').find('.mce-response-output').html(response.msg);
      } else {
        $('#mce-error-response').html(response.msg).removeClass('hidden');
      }
    }
  });

  //custom checkboxes
  $('#consent').on('click', function() {
    console.log('Consent clicked');

    if ($(this).is(':checked')) {
      $('#mc-embedded-subscribe-form').find('button[type="submit"]').removeAttr('disabled');
    } else {
      $('#mc-embedded-subscribe-form').find('button[type="submit"]').attr('disabled','disabled');
    }
  });

  // Cookie consent
  if (localStorage.getItem('CookieSConsentTWOTHIRDS') != 'shown') {
    $('#cookie-banner').delay(2000).fadeIn();
    localStorage.setItem('CookieSConsentTWOTHIRDS','shown')
  };
  $('#agree-cookie-consent').click(function() {
    $('#cookie-banner').fadeOut();
  });


  /*
  Item name: jQuery Accordion Menu
  Author: http://codecanyon.net/user/marcoarib
  License: http://codecanyon.net/licenses
  */

  ;(function ( $, window, document, undefined ) {

  	var pluginName = "jqueryAccordionMenu";
  	var defaults = {
  			speed: 300,
  			showDelay: 0,
  			hideDelay: 0,
  			singleOpen: true,
  			clickEffect: true
  		};

  	function Plugin ( element, options ) {
  		this.element = element;
  		this.settings = $.extend( {}, defaults, options );
  		this._defaults = defaults;
  		this._name = pluginName;
  		this.init();
  	};

  	$.extend(Plugin.prototype, {

  		init: function () {
  			this.openSubmenu();
  			this.submenuIndicators();
  			if(this.settings.clickEffect){
  				this.addClickEffect();
  			}
  		},

  		openSubmenu: function () {
  			var opts = this.settings; //to differ from local variable "this"
  			$(this.element).children("ul").find("li").bind("click touchstart", function(e){
  				e.stopPropagation();
  				e.preventDefault();
  				if($(this).children(".submenu").length > 0){
  					if($(this).children(".submenu").css("display") == "none"){
  						$(this).children(".submenu").delay(opts.showDelay).slideDown(opts.speed);
  						$(this).children(".submenu").siblings("a").addClass("submenu-indicator-minus");
  						if(opts.singleOpen){
  							$(this).siblings().children(".submenu").slideUp(opts.speed);
  							$(this).siblings().children(".submenu").siblings("a").removeClass("submenu-indicator-minus");
  						}
  						return false;
  					}
  					else{
  						$(this).children(".submenu").delay(opts.hideDelay).slideUp(opts.speed);
  					}
  					if($(this).children(".submenu").siblings("a").hasClass("submenu-indicator-minus")){
  						$(this).children(".submenu").siblings("a").removeClass("submenu-indicator-minus");
  					}
  				}
  				window.location.href = $(this).children("a").attr("href");
  			});
  		},

  		submenuIndicators: function () {
  			if($(this.element).find(".submenu").length > 0){
  				$(this.element).find(".submenu").siblings("a").append("<span class='submenu-indicator'>+</span>");
  			}
  		},

  		addClickEffect: function () {
  			var ink, d, x, y;
  			$(this.element).find("a").bind("click touchstart", function(e){

  				$(".ink").remove();

  				if($(this).children(".ink").length === 0){
  					$(this).prepend("<span class='ink'></span>");
  				}

  				ink = $(this).find(".ink");
  				ink.removeClass("animate-ink");

  				if(!ink.height() && !ink.width()){
  					d = Math.max($(this).outerWidth(), $(this).outerHeight());
  					ink.css({height: d, width: d});
  				}

  				x = e.pageX - $(this).offset().left - ink.width()/2;
  				y = e.pageY - $(this).offset().top - ink.height()/2;

  				ink.css({top: y+'px', left: x+'px'}).addClass("animate-ink");
  			});
  		}

  	});

  	$.fn[ pluginName ] = function ( options ) {
  		this.each(function() {
  			if ( !$.data( this, "plugin_" + pluginName ) ) {
  				$.data( this, "plugin_" + pluginName, new Plugin( this, options ) );
  			}
  		});
  		return this;
  	};

  })( jQuery, window, document );

  // Mobile navigation accordion
  $("#mobile-menu").awsAccordion({
    type:"vertical",
    cssAttrsHor:{
        ulWidth:"responsive",
        liHeight:300,
        liWidth:50
    },
    startSlide:0,
    openOnebyOne:true,
    classTab:"expanded",
    slideOn:"click",
    autoPlay:false,
    autoPlaySpeed:2000
  });


  // Lookbook navigation SLIDER
  var lookbook_nav_slider = $('.lookbooks-slider-nav');

  // Slide on next/prev image click
  lookbook_nav_slider.slick({
    autoplay: false,
    arrows: false,
    dots: false,
    zIndex: 20,
    draggable: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    centerMode: true,
    centerPadding: '60px',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  });

});
